import { ReactNode } from 'react';
import ErrorBoundary from '../shared/components/ErrorBoundary';
import { SecurityProvider } from '../shared/components/SecurityProvider';
import { AuthProvider } from '../features/auth/AuthContext';
import { FavoritesProvider } from '../features/properties/FavoritesContext';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary>
      <SecurityProvider>
        <AuthProvider>
          <FavoritesProvider>{children}</FavoritesProvider>
        </AuthProvider>
      </SecurityProvider>
    </ErrorBoundary>
  );
}
